export default "__VITE_ASSET__02c31505__"